export default __webpack_public_path__ + "images/66fc1f793420c03a929d04aa31894930.png";